import { isErrorResponse, isHandledErrorResponse, isRequestAborted, isUnauthorizedResponse } from "core/api/apiHelpers";
import type { ErrorContext, Middleware, ResponseContext } from "core/api/coreApiClient";
import ExceptionLogger from "core/utilities/ExceptionLogger/ExceptionLogger";

class LoggerMiddleware implements Middleware {
  post = async (responseContext: ResponseContext) => {
    const { url, response } = responseContext;

    // logRequestError decides upon whether the error response will actually be logged
    if (
      // i.e. network errors or blocked requests through chrome network tab don't have any response status
      (!response.status || isErrorResponse(response.status)) &&
      !isUnauthorizedResponse(response.status) &&
      !isHandledErrorResponse(response.status)
    ) {
      if (
        !url.match("discovery/contextPath") &&
        // Avoid an endless loop if the log endpoint is not available
        !url.match("logging/error") &&
        !url.match("logging/debug")
      ) {
        ExceptionLogger.logRequestError(
          `API: ${response.status || "Status missing"} - ${response.statusText || "Status text missing"}`,
          responseContext,
          response
        );
      }
    }

    return Promise.resolve(response);
  };

  // Thrown when it fails to get an HTTP response / network error / chrome block url via network tab

  onError = async (errorContext: ErrorContext) => {
    const { url, error, response } = errorContext;

    if (
      !url.match("discovery/contextPath") &&
      !url.match("logging/error") &&
      !url.match("logging/debug") &&
      !isRequestAborted(error)
    ) {
      ExceptionLogger.logRequestError(error as Error | string, errorContext, undefined, [`Request: ${url}`]);
    }

    return Promise.resolve(response);
  };
}

export default LoggerMiddleware;
